import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

const capaListSearch = z.object({
  page: z.number().int().min(1).optional(),
  sort: z.string().optional(),
  filters: z.record(z.string(), z.array(z.string())).optional(),
  // finding detail-drawer id
  findingId: z.string().optional(),
  mode: z.enum(['internal', 'external']).optional(),
  tab: z.string().optional(),
  // actions-specific
  quickFilter: z
    .enum(['all', 'assignedToMe', 'reportedByMe', 'internal', 'external'])
    .optional(),
});

export const Route = createFileRoute('/(client)/capa/(pages)/(list)')({
  validateSearch: capaListSearch,
  component: lazyRouteComponent(
    () => import('../../-components/CapaLayout'),
    'CapaLayout',
  ),
});
